




























































import { defineComponent } from '@nuxtjs/composition-api';
import SkeletonLoader from '~/components/SkeletonLoader/index.vue';
import { useUser } from '~/composables';

export default defineComponent({
  name: 'AnalysisSkeleton',
  components: {
    SkeletonLoader,
  },
  setup() {
    const { isAuthenticated } = useUser();

    return {
      isAuthenticated,
    };
  },
});
